import React from "react";
import PlaylistPlayRoundedIcon from "@mui/icons-material/PlaylistPlayRounded";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import SkipPreviousRoundedIcon from "@mui/icons-material/SkipPreviousRounded";
import SkipNextRoundedIcon from "@mui/icons-material/SkipNextRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import OpenInFullSharpIcon from "@mui/icons-material/OpenInFullSharp";
import { isMobileSafari } from "react-device-detect";

import {
  setCustomModal,
  setModalType,
} from "../../../redux/features/settingSlice";
import {
  getPlayerState,
  setFullscreenFunc,
  setMinimizePlayer,
  setPlayAll,
  setPlaybackRate,
  setPlaying,
} from "../../../redux/features/playerSlice";
import CustomCircleButton from "../CustomCircleButton";

const ButtonsPlayer = ({ data, urlLink, topicMode, trigger }) => {
  const {
    playing,
    playedPercent,
    minimizePlayer,
    fullscreenFunc,
    videoLandscape,
    playbackRate,
  } = useSelector(getPlayerState);

  const theme = useTheme();
  const smWidth = useMediaQuery(theme.breakpoints.up("xs"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const nextTopic = topicMode ? data?.next_topic : data?.next_converse;
  const prevTopic = topicMode ? data?.previous_topic : data?.previous_converse;

  const handlePlayPause = () => {
    dispatch(setPlayAll(false));

    dispatch(setPlaying(!playing));
    minimizePlayer && dispatch(setMinimizePlayer(true));
  };

  const handlePlayListModal = () => {
    dispatch(setCustomModal(true));
    dispatch(setModalType("PlayList"));
  };

  const handleClickFullscreen = () => {
    dispatch(setFullscreenFunc(fullscreenFunc + 1));
  };

  const handlePlaybackRate = () => {
    if (playbackRate === 1.0) {
      dispatch(setPlaybackRate(1.5));
    } else {
      dispatch(setPlaybackRate(1.0));
    }
  };

  const handleNavigate = (topic) => {
    trigger({ time_watched: playedPercent * data?.duration });

    topic && navigate(urlLink + topic.pk, { replace: true });
  };

  const goToComment = () => {
    trigger({ time_watched: playedPercent * data?.duration });

    navigate(
      `/table/${params.tableId}/${
        topicMode
          ? `opinions/${params.opinionId}`
          : `discussions/${params.discussionId}`
      }/topics/${data?.pk}/comment`
    );
  };

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 74,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Typography
        onClick={handlePlaybackRate}
        sx={{
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          bottom: "73px",
          width: "100%",
          color: playbackRate === 1.0 ? "#9e9e9e" : "#ffffff",
        }}
      >
        x1.5
      </Typography>

      {videoLandscape && !isMobileSafari && (
        <Box
          onClick={handleClickFullscreen}
          sx={{
            position: "absolute",
            right: 0,
            top: -34,
            backgroundColor: "white.main",
            height: "24px",
            borderRadius: "6px",
            border: "1px solid",
            borderColor: "black.main",
            display: "flex",
            alignItems: "center",
            width: "90px",
            px: "2px",
            cursor: "pointer",
          }}
        >
          <OpenInFullSharpIcon sx={{ fontSize: "16px" }} />
          <Typography
            sx={{
              textAlign: "left",
              fontSize: "11px",
              p: "4px 0 0 8px",
              height: "100%",
            }}
          >
            full-screen
          </Typography>
        </Box>
      )}
      <CustomCircleButton
        onClick={handlePlayListModal}
        width={smWidth ? "40px" : "36px"}
        height={smWidth ? "40px" : "36px"}
        bgColor='white.main'
        color='black.main'
        bShadow='none'
        border='2px solid'
        hoverBgColor='white.main'
        hoverColor='black.main'
        hoverBorder={`2px solid`}
        activeBgColor='black.main'
        activeColor='white.main'
      >
        <PlaylistPlayRoundedIcon sx={{ fontSize: "24px", ml: "3px" }} />
      </CustomCircleButton>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          maxWidth: 208,
        }}
      >
        <Box sx={{ mr: "24px" }}>
          <CustomCircleButton
            onClick={() => handleNavigate(prevTopic)}
            disabled={!prevTopic}
            width={smWidth ? "48px" : "42px"}
            height={smWidth ? "48px" : "42px"}
            bgColor='primary.main'
            color='black'
            bShadow='none'
            border='2px solid'
            hoverBgColor='primary.main'
            hoverColor='black'
            activeBgColor='black.main'
            activeColor='white.main'
          >
            <SkipPreviousRoundedIcon sx={{ fontSize: "34px", pr: "2px" }} />
          </CustomCircleButton>
        </Box>

        <Box sx={{ mr: "24px" }}>
          <CustomCircleButton
            onClick={handlePlayPause}
            width={smWidth ? "64px" : "58px"}
            height={smWidth ? "64px" : "58px"}
            bgColor='primary.main'
            color='black'
            bShadow='none'
            border='2px solid'
            hoverBgColor='primary.main'
            hoverColor='black'
            activeBgColor='black.main'
            activeColor='white.main'
            focusBtn
          >
            {playing ? (
              <PauseRoundedIcon sx={{ fontSize: "30px" }} />
            ) : (
              <PlayArrowRoundedIcon sx={{ fontSize: "38px" }} />
            )}{" "}
          </CustomCircleButton>
        </Box>
        <Box>
          <CustomCircleButton
            onClick={() => handleNavigate(nextTopic)}
            disabled={!nextTopic}
            width={smWidth ? "48px" : "42px"}
            height={smWidth ? "48px" : "42px"}
            bgColor='primary.main'
            color='black'
            bShadow='none'
            border='2px solid'
            hoverBgColor='primary.main'
            hoverColor='black'
            activeBgColor='black.main'
            activeColor='white.main'
          >
            <SkipNextRoundedIcon sx={{ fontSize: "34px", pl: "2px" }} />
          </CustomCircleButton>
        </Box>
      </Box>
      <CustomCircleButton
        onClick={goToComment}
        width={smWidth ? "40px" : "36px"}
        height={smWidth ? "40px" : "36px"}
        bgColor='white.main'
        color='black.main'
        bShadow='none'
        border='2px solid'
        hoverBgColor='white.main'
        hoverColor='black.main'
        hoverBorder={`2px solid`}
        activeBgColor='black.main'
        activeColor='white.main'
      >
        <TextsmsOutlinedIcon
          sx={{
            fontSize: "22px",
            ml: "2px",
          }}
        />
        {data?.comments_count > 0 && (
          <Box
            sx={{
              width: "10px",
              height: "10px",
              backgroundColor: "danger.main",
              borderRadius: "50%",
              border: "1px solid white",
              position: "absolute",
              right: 2,
              top: 3,
            }}
          ></Box>
        )}
        <Typography
          sx={{
            fontSize: "10px",
            zIndex: 22,
            position: "absolute",
            right: "8px",
            bottom: "5px",
            padding: "2px 2px 0 2px",
            backgroundColor: "white.main",
            lineHeight: "11px",
          }}
        >
          {data?.comments_count}
        </Typography>
      </CustomCircleButton>
    </Box>
  );
};
export default ButtonsPlayer;
